import { Coordinates } from "./types";

/**
 * ポインター座標を画像上の正規化座標に変換するユーティリティ
 */
export class CoordinateConverter {
  /**
   * クライアント座標（ページ座標）を画像座標の比率に変換
   * @param el 対象要素
   * @param clientX ページ座標 X
   * @param clientY ページ座標 Y
   * @param rotationDeg 回転角度（度）
   * @param scale スケール（拡縮倍率）
   * @returns 正規化された比率 (0-1)
   */
  static clientToRatio(
    el: HTMLElement,
    clientX: number,
    clientY: number,
    rotationDeg: number,
    scale: number
  ): Coordinates {
    const rect = el.getBoundingClientRect();

    // 要素中心を基準にローカル座標
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const localX = (clientX - cx) / scale;
    const localY = (clientY - cy) / scale;

    // 回転を逆適用（-rotation）
    const rad = (rotationDeg * Math.PI) / 180;
    const cos = Math.cos(rad);
    const sin = Math.sin(rad);
    const rx = localX * cos + localY * sin;
    const ry = -localX * sin + localY * cos;

    // 要素のレイアウトサイズで正規化
    const w = el.clientWidth;
    const h = el.clientHeight;
    const xRatio = 0.5 + rx / w;
    const yRatio = 0.5 + ry / h;

    return { xRatio, yRatio };
  }
}

// 後方互換性のためのデフォルトエクスポート
export default CoordinateConverter;